import { render, staticRenderFns } from "./PolicyExclusions.vue?vue&type=template&id=0bd02411&"
import script from "./PolicyExclusions.vue?vue&type=script&lang=js&"
export * from "./PolicyExclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports